import { Children } from 'react';
import { useTranslation } from 'react-i18next';

import { User } from 'model/User';
import { YN_TYPE } from 'types/enumType';
import { convertRoleToString } from 'util/commonUtil';

type UserSearchTableProps = {
  userList: User[];
  onSelect: (user: User) => void;
};

export default function UserSearchTable({
  userList,
  onSelect,
}: UserSearchTableProps) {
  const { t } = useTranslation();

  return (
    <table className={'tbl_ht01'}>
      <caption>{t('conclusion.searchList')}</caption>
      <colgroup>
        <col width={''} />
        <col width={''} />
        <col width={''} />
        <col width={''} />
      </colgroup>
      <thead>
        <tr>
          <th>{t('coop.group')}</th>
          <th>{t('user.deptName')}</th>
          <th>{t('user.role')}</th>
          <th>{t('user.id')}</th>
          <th>{t('user.name')}</th>
        </tr>
      </thead>
      <tbody>
        {!userList || userList?.length === 0 ? (
          <tr>
            <td colSpan={9}>{t('conclusion.noData')}</td>
          </tr>
        ) : (
          Children.toArray(
            userList.map((user) => (
              <tr onClick={() => onSelect(user)}>
                <td className={'left'}>
                  {user.inHouseYn === YN_TYPE.Y
                    ? '자사'
                    : `${t('coop.coop')}(${user.coopName})`}
                </td>
                <td className={'left'}>{user.division}</td>
                <td className={'left'}>{convertRoleToString(user.role)}</td>
                <td className={'left'}>{user.account}</td>
                <td className={'left'}>{user.name}</td>
              </tr>
            )),
          )
        )}
      </tbody>
    </table>
  );
}
